module.exports = __webpack_public_path__ + "static/media/delete.a439d0a8.svg";